var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpinner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-2850,-1250)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,104.907,-67)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2787.68,1359.68C2792.37,1354.99 2795,1348.63 2795,1342C2795,1336.72 2793.33,1331.58 2790.22,1327.31L2785.77,1330.54C2788.19,1333.87 2789.49,1337.88 2789.49,1342C2789.49,1347.17 2787.44,1352.13 2783.78,1355.78L2787.68,1359.68Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,105,-67)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2770,1317C2783.8,1317 2795,1328.2 2795,1342C2795,1355.8 2783.8,1367 2770,1367C2756.2,1367 2745,1355.8 2745,1342C2745,1328.2 2756.2,1317 2770,1317ZM2770,1322.51C2780.76,1322.51 2789.49,1331.24 2789.49,1342C2789.49,1352.76 2780.76,1361.49 2770,1361.49C2759.24,1361.49 2750.51,1352.76 2750.51,1342C2750.51,1331.24 2759.24,1322.51 2770,1322.51Z",
    style: {
      fill: "white",
      fillOpacity: 0.43
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.400a8877989c7ea2ec9fe3e1a696d086.svg";
export { ForwardRef as ReactComponent };